module.exports = __webpack_public_path__ + "static/img/image_support_article_details_p7.40bc49b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/support/image_support_article_details_p7.png
// module id = pTvx
// module chunks = 10